import React from "react";
import ReportIssueManagementTable from "./ReportIssueManagementTable";

const ReportIssueFormManagement = () => {

  return <div>{<ReportIssueManagementTable  />}</div>;
};

export default ReportIssueFormManagement;
